// Testimonios reales que le mandaron a Brian por mensaje privado de Instagram.
//
// Por qué viven acá y no en locales/*.json: NO son copy traducible. Son 28
// mensajes distintos, cada uno escrito en su idioma por una persona distinta, y
// nunca se traducen entre sí. Ponerlos en los locales daría a entender que son
// el mismo texto en 7 idiomas, y no lo son. La excepción es un idioma sin
// mensajes propios (PRESTADOS): muestra los de otro, traducidos y avisando que
// el original está en la captura (TRADUCCIONES, VER_ORIGINAL).
//
// Van SIN nombre, igual que las capturas: ninguna de las 28 muestra nombre ni
// @usuario. No inventar nombres: sin un autor real no se puede emitir Review en
// JSON-LD, y firmar con una persona que no existe sería una reseña falsa.
//
// El texto es verbatim, con los errores de tipeo y las mayúsculas del original.
// No corregirlo: es una cita.
//
// `dim` son las medidas reales del PNG (ancho, alto), medidas de los archivos.
// Hoy no las usa esta sección, que ya no muestra miniatura. Quedan porque
// `home-universo` todavía declara 600x300 para estos mismos PNG y ninguno mide
// eso: cuando esa sección se migre al componente compartido, el dato ya está.
//
// `pais` no se muestra: queda como parte de la transcripción, porque el dato lo
// dice el propio mensaje ("un abrazo desde Chile"), no lo agregamos nosotros.
//
// `libros` son los slugs de ficha (/libro/<slug>) que el mensaje nombra
// explícitamente. No es una etiqueta editorial nuestra: sale de leer la cita
// ("estoy usando Armonía Ilustrada" -> ai). Sin `libros` = el mensaje no nombra
// ningún libro y sirve en cualquier ficha. Para qué se usa, ver
// FICHAS_SIN_TESTIMONIOS_DE_OTRO_LIBRO al final del archivo.
//
// Generado el 2026-08-20 transcribiendo public/images/comments/*.png.

export const TESTIMONIOS = {
  es: [
    {
      img: "/images/comments/comment_es_01.png",
      dim: [520, 120],
      libros: ["ai"],
      texto: "Holaa! Solo quería darte las gracias. Soy profe de piano y estoy usando Armonía Ilustrada con mis alumnos, la diferencia es ABISMAL. Entienden todo muchísimo más rápido con las ilustraciones 🙌",
    },
    {
      img: "/images/comments/comment_es_02.png",
      dim: [520, 200],
      libros: ["ai", "ai2"],
      texto: "Hola Brian! Te escribo porque necesito agradecerte. Soy autodidacta, toco guitarra y ukelele, y la verdad es que siempre sentí que la teoría era como un muro gigante que no podía escalar. Compré armonía ilustrada vol 1 y 2 y por primera vez siento que PUEDO. Que no es imposible. Hasta lloré un poquito cuando empecé a conectar cosas que antes no entendía. Un abrazo enorme desde Chile ❤️",
      pais: "Chile",
    },
    {
      img: "/images/comments/comment_es_03.png",
      dim: [520, 120],
      texto: "Lo visual lo cambia TODO. Llevo años leyendo libros de armonía y es la primera vez que veo las relaciones entre acordes de forma tan clara. Es como si me hubieras dado lentes nuevos para ver la musica. Gracias crack 🔥",
    },
    {
      img: "/images/comments/comment_es_04.png",
      dim: [520, 160],
      libros: ["mi"],
      texto: "Wey te cuento que compré los 4 libros de una y no me arrepiento de NADA. Soy productor y siempre trabajé de oido pero ahora entiendo POR QUÉ funcionan las cosas que hago intuitivamente. El de modos ilustrados es una locura, la forma en que usas los colores para diferenciar cada modo es brillante. Se nota que hay mucho laburo atras de esto 👏👏",
    },
  ],
  en: [
    {
      img: "/images/comments/comment_en_01.png",
      dim: [520, 180],
      libros: ["ti"],
      texto: "Hey Brian, just wanted to reach out. I studied music composition at Berklee and I genuinely wish I had your books back then. Not because my professors were bad, but because your visual approach would have cut my learning curve in HALF. Picked up Tensions Illustrated last week and it's brilliant. The way you map out tensions over chord types is something I haven't seen anyone else do this clearly. Respect man.",
    },
    {
      img: "/images/comments/comment_en_02.png",
      dim: [520, 180],
      libros: ["ai"],
      texto: "Brian I have to be honest with you. I almost didn't buy your books because I've wasted SO much money on music theory courses and books that promised everything and delivered nothing. Bought Harmony Illustrated on a whim and I literally sat there with my mouth open. After 20+ years of playing guitar I finally see the bigger picture. This is not an exaggeration. You cracked the code man",
    },
    {
      img: "/images/comments/comment_en_03.png",
      dim: [520, 120],
      texto: "THE COLORS. Thats what gets me. The way you use color to show relationships between notes and chords... my brain just GETS it now. Bought all of them btw 😅",
    },
    {
      img: "/images/comments/comment_en_04.png",
      dim: [520, 120],
      libros: ["ai"],
      texto: "Bro I showed your Harmony Illustrated to my guitar teacher and he literally ordered a copy for himself on the spot 😂 said he wished he had something like this when he was studying. Thats the best review I can give you honestly",
    },
  ],
  pt: [
    {
      img: "/images/comments/comment_pt_01.png",
      dim: [520, 140],
      libros: ["ai"],
      texto: "Brian, cara, eu tô sem palavras. Comprei o Harmonia Ilustrada vol 1 faz uma semana e já entendi mais do que em 3 anos de aula particular. Aqueles diagramas com cores são GENIAIS. Sério, eu ficava travado tentando entender campo harmônico e agora tá tudo ali, visual, óbvio. Obrigadão mano 🙏 🙏",
    },
    {
      img: "/images/comments/comment_pt_02.png",
      dim: [520, 120],
      texto: "oi Brian!! acabei de receber os livros e to chorando aqui kkk que coisa mais linda, parece arte e ao mesmo tempo explica tudo que eu nunca consegui entender 😭 ❤️",
    },
    {
      img: "/images/comments/comment_pt_03.png",
      dim: [520, 100],
      texto: "mano comprei ontem e nao dormi a noite toda vendo os livros kkkkk que viagem, é tipo um mapa do tesouro da harmonia 🗺️ 🔥 🔥 🔥",
    },
    {
      img: "/images/comments/comment_pt_04.png",
      dim: [520, 160],
      libros: ["ai", "ai2", "mi"],
      texto: "Oi! Comprei o harmonia ilustrada vol 1 e 2 semana passada. Estudei no conservatório por 4 anos e sempre achei harmonia um bicho de sete cabeças. Qnd abri seus livros foi literalmente como se alguém tivesse acendido a luz. Tudo q eu decorava sem entender agora FAZ SENTIDO visualmente. Chorei de alivio serio kkk. Ja encomendei o de modos tbm. Obrigadaaaa 🥹 🙏",
    },
  ],
  fr: [
    {
      img: "/images/comments/comment_fr_01.png",
      dim: [520, 180],
      libros: ["ai", "ai2"],
      texto: "Salut Brian! J'ai reçu Armonía Ilustrada vol 1 et 2 hier et franchement... je suis sans voix. Ça fait 12 ans que je joue de la guitare et j'ai jamais vu l'harmonie présentée comme ça. Les diagrammes avec les couleurs c'est juste BRILLANT. J'ai compris en 20 minutes des trucs que j'ai galéré à saisir pendant des années au conservatoire 🤯🔥",
    },
    {
      img: "/images/comments/comment_fr_02.png",
      dim: [520, 80],
      texto: "Frero c'est la meilleure chose que j'ai achetée pour la musique. Point final. 🔥🔥",
    },
    {
      img: "/images/comments/comment_fr_03.png",
      dim: [520, 120],
      libros: ["glue"],
      texto: "Salam Brian je voulais juste te dire MERCI. Le Glue Mágico c'est exactement ce que je cherchais depuis des mois. J'arrivais pas a lier mes accords et mes gammes ensemble et maintenant je comprend le pourquoi du comment. Ça vaut 100x le prix 💪",
    },
    {
      img: "/images/comments/comment_fr_04.png",
      dim: [520, 140],
      texto: "Allo Brian!! Je suis au Québec et je viens de déballer mes livres 📚 OH MON DIEU c'est trop beau!! Les illustrations sont incroyables et en plus ça a du sens haha. Ça rend la théorie musicale presque... fun?? Merci merci merci CA ❤️",
      pais: "Québec",
    },
  ],
  it: [
    {
      img: "/images/comments/comment_it_01.png",
      dim: [520, 180],
      libros: ["ai", "ai2"],
      texto: "Ciao Brian! Ho appena ricevuto Armonia Illustrata vol 1 e 2 e devo dirti che sono SENZA PAROLE. Suono il basso da 15 anni e ho sempre faticato con l'armonia, ho provato libri del conservatorio, corsi online, tutto... ma nessuno mi ha mai fatto VEDERE la musica così. Quando ho aperto la prima pagina con quei diagrammi a colori ho pensato \"ma perché nessuno l'ha fatto prima?!\" Grazie mille 🙏🙏",
    },
    {
      img: "/images/comments/comment_it_02.png",
      dim: [520, 160],
      libros: ["mi"],
      texto: "Brian ti scrivo perché devo ringraziarti. Sono pianista classica e ho sempre avuto un blocco con l'improvvisazione e la composizione. Con Modi Illustrati ho finalmente capito cose che i miei prof non sono mai riusciti a spiegarmi in modo chiaro 😭❤️",
    },
    {
      img: "/images/comments/comment_it_03.png",
      dim: [520, 160],
      libros: ["ti"],
      texto: "Ciao! Ho comprato ieri Tensioni Illustrate e sto ancora cercando di capire come hai fatto a rendere un argomento così complesso così... ovvio? Nel senso, le tensioni le ho studiate al conservatorio per mesi e non ci avevo capito granché. Con le tue illustrazioni è come se il cervello facesse click. Complimenti davvero, sei un genio",
    },
    {
      img: "/images/comments/comment_it_04.png",
      dim: [520, 160],
      libros: ["ai"],
      texto: "Ciaoo! Sono una sassofonista jazz e insegno in una scuola di musica a Bologna. Ho ordinato Armonia Illustrata per curiosità e adesso lo sto consigliando a TUTTI i miei studenti. La parte visiva è qualcosa di rivoluzionario, i ragazzi capiscono in una lezione quello che prima ci mettevamo settimane a spiegare. Grazie di cuore Brian ❤️🎷",
      pais: "Bologna",
    },
  ],
  de: [
    {
      img: "/images/comments/comment_de_01.png",
      dim: [520, 60],
      texto: "Alter. Ich checks endlich. Nach Jahren. JAHREN. Danke man 🙏",
    },
    {
      img: "/images/comments/comment_de_02.png",
      dim: [520, 160],
      texto: "Brian ich muss dir was sagen... ich hab vor 3 Jahren angefangen Klavier zu lernen und Harmonielehre war immer wie ne Mauer für mich. Hab sogar überlegt aufzuhören. Dann hab ich über Instagram dein Buch gefunden und es war als ob jemand das Licht anmacht 😭 Jetzt komponiere ich meine eigenen Stücke. Das hätt ich mir nie vorstellen können. Vielen vielen Dank",
    },
    {
      img: "/images/comments/comment_de_03.png",
      dim: [520, 100],
      libros: ["mi"],
      texto: "Hab Modos Ilustrados grade durch und wow. Endlich ergibt dorisch mixolydisch und der ganze rest SINN. Visuell dargestellt is es so logisch 🤯 🤯",
    },
    {
      img: "/images/comments/comment_de_04.png",
      dim: [520, 160],
      texto: "Servus Brian! Bin Gitarrist aus Salzburg, spiele seit 20 Jahren und dachte ich weiß alles über Harmonielehere. Dein Buch hat mir gezeigt dass ich vieles zwar gespielt aber nie wirklich VERSTANDEN hab. Die Grafiken machen es so klar. Bestes Geld das ich je ausgegeben hab für Musikmaterial. Respekt 👏",
      pais: "Salzburg",
    },
  ],
  ja: [
    {
      img: "/images/comments/comment_ja_01.png",
      dim: [520, 160],
      libros: ["ai"],
      texto: "Brianさん、こんにちは！ Armonía Ilustradaを買ったんですが、もう本当にびっくりしました。音大で4年間ずっと苦しんでた和声学が、この本のビジュアルで一瞬で「あ、そういうことか！」ってなりました。泣きそうです😭 なんでもっと早く出会えなかったんだろう…",
    },
    {
      img: "/images/comments/comment_ja_02.png",
      dim: [520, 140],
      libros: ["glue"],
      texto: "Brian先生！！ Glue Mágico届きました〜🎸✨ まだ全部読めてないんですけど、最初の数ページだけでもう目から鱗です。ギター歴3年でずっと独学なんですが、コード進行の作り方がこんなに視覚的にわかるなんて思ってもみなかったです。友達にも勧めまくってます笑",
    },
    {
      img: "/images/comments/comment_ja_03.png",
      dim: [520, 160],
      libros: ["ti"],
      texto: "ジャズピアノやってる者です。正直最初は「イラストで和声？」って半信半疑だったんですけど、Tensiones Ilustradas読んで考え変わりました。テンションの関係性があのダイアグラムで見えた瞬間、長年のモヤモヤが一気に晴れた感じです。音楽教室で生徒にも使わせてもらってます。みんな理解が早い！！",
    },
    {
      img: "/images/comments/comment_ja_04.png",
      dim: [520, 140],
      libros: ["mi"],
      // Cita recortada, y es la unica de las 28 que se recorta. El mensaje
      // original sigue con «日本語版も出してほしい…！！ でも図だけで十分理解できる
      // のがこの本のすごいところですね»: la persona lo leyo en otro idioma y pedia
      // una edicion japonesa, que HOY EXISTE. Publicado como texto en la landing
      // japonesa, al lado del FAQ que dice que esta en los siete idiomas, le
      // estaria diciendo a un comprador japones que no hay version en su idioma.
      // La captura completa sigue estando a un click, sin recortar.
      texto: "サックス吹きです。モードの本、人生変わりました。大げさじゃなくて本当に。ドリアンとミクソリディアンの違いがこんなに明確に「見える」教材は他にない。",
    },
  ],
};

// El link a la captura original. Va como texto y no como miniatura: a 72px una
// captura de texto es una mancha ilegible, parece un error de render.
export const VER_CAPTURA = {
  es: "ver captura",
  en: "see screenshot",
  pt: "ver captura",
  fr: "voir la capture",
  de: "Screenshot ansehen",
  it: "vedi lo screenshot",
  ja: "スクショを見る",
  tr: "ekran görüntüsünü gör",
};

// Idioma sin mensajes propios todavía: muestra los de otro idioma, traducidos (ver
// TRADUCCIONES). Sin esto caía a los de español. Al tener capturas reales en ese
// idioma, se agregan a TESTIMONIOS y se borra la línea de acá y su traducción.
const PRESTADOS = { tr: "en" };

// Los mensajes prestados, traducidos al idioma de la página, en el mismo orden que
// TESTIMONIOS[<prestado>]. Fede (6-oct-2026): en /tr se veían en inglés y pidió
// traducirlos. Se traducen desde el original (así los escribió cada persona) y la
// tarjeta lo dice: el link a la captura pasa a ser VER_ORIGINAL, que abre el
// mensaje tal cual. Sin traducción para un índice, queda el original.
const TRADUCCIONES = {
  tr: [
    "Selam Brian, sana yazmak istedim. Berklee'de müzik kompozisyonu okudum ve keşke o zamanlar senin kitapların elimde olsaydı. Hocalarım kötü olduğu için değil, senin görsel yaklaşımın öğrenme sürecimi YARI YARIYA kısaltacağı için. Geçen hafta Resimli Gerilim Notaları'nı aldım, harika. Gerilimleri akor türlerinin üzerine yerleştirme şeklini kimsenin bu kadar net yaptığını görmedim. Saygılar dostum.",
    "Brian, sana karşı dürüst olmalıyım. Kitaplarını neredeyse almıyordum, çünkü her şeyi vaat edip hiçbir şey vermeyen müzik teorisi kurslarına ve kitaplarına ÇOK para harcadım. Resimli Armoni'yi bir anlık hevesle aldım ve resmen ağzım açık kaldı. 20 yılı aşkın süredir gitar çalıyorum ve sonunda resmin bütününü görüyorum. Abartmıyorum. Şifreyi çözmüşsün dostum",
    "RENKLER. Beni asıl etkileyen bu. Notalar ve akorlar arasındaki ilişkileri renklerle gösterme şeklin... beynim artık direkt ANLIYOR. Bu arada hepsini aldım 😅",
    "Kanka, Resimli Armoni'yi gitar hocama gösterdim, adam anında kendine bir tane sipariş etti 😂 Öğrenciyken böyle bir şeyi olsun isterdim dedi. Açıkçası sana verebileceğim en iyi yorum bu",
  ],
};

// El link de una cita traducida: abre la misma captura, pero avisa que es el original.
export const VER_ORIGINAL = {
  tr: "orijinalini gör (İngilizce)",
};

// El idioma cuyos testimonios se muestran para ese locale. home-universo arma con
// esto el nombre de las capturas (comment_<idioma>_NN.png).
export function idiomaDeTestimonios(locale) {
  const idioma = String(locale || "");
  if (TESTIMONIOS[idioma]) return idioma;
  return PRESTADOS[idioma] || "es";
}

// Fichas donde un testimonio que nombra OTRO libro no se publica.
//
// Hoy la lista va VACIA a proposito, y conviene saber por que antes de volver a
// llenarla. El candidato natural era Glue Magico para Guitarristas, el unico
// libro de un instrumento y no de todos, que la ficha ya trata aparte en otros
// dos lugares (el bullet l2_item_instruments y la primera pregunta del FAQ de
// coleccion, las dos salteadas con `slug === "glue"`). Pero se midio el efecto y
// no compensa: en /libro/glue el filtro dejaba es 1, en 1, pt 2, fr 3, it 0,
// de 3, ja 1. O sea una sola cita en espaniol y la seccion entera caida en
// italiano, porque los cuatro mensajes italianos nombran otro libro.
//
// Cambiar tres cuartas partes de la prueba social de una pagina de venta por una
// coherencia que el lector no percibe es mal negocio: el mensaje del profe de
// piano nombra Armonia Ilustrada, no dice en ningun momento que Glue sea para
// piano, y el titulo de la seccion es de marca ("Lo que dicen los musicos").
//
// El campo `libros` de cada testimonio queda igual porque es dato real, sale de
// leer la cita, y lo va a necesitar cualquier cosa que quiera prueba social por
// libro. El dia que haya material suficiente por libro, esto se enciende
// agregando el slug aca y ya funciona.
export const FICHAS_SIN_TESTIMONIOS_DE_OTRO_LIBRO = [];

// El componente Testimonials recibe `locale` y se lo pasa tal cual a estas dos
// funciones, así que la ficha manda `{ locale, slug }` por ese mismo parámetro
// para poder filtrar por libro sin cambiarle la firma al componente compartido,
// que lo usan además seis landings. Un string sigue funcionando igual que antes.
function leerDestino(valor) {
  if (valor && typeof valor === "object") {
    return { locale: valor.locale, slug: valor.slug || null };
  }
  return { locale: valor, slug: null };
}

// Devuelve los testimonios del idioma pedido (los prestados, traducidos). Si un
// idioma no tuviera, cae a español antes que romper la sección.
export function testimoniosDe(locale) {
  const { locale: idioma, slug } = leerDestino(locale);
  const traducciones = TRADUCCIONES[idioma];
  const items = traducciones
    ? TESTIMONIOS[idiomaDeTestimonios(idioma)].map((t, i) =>
        traducciones[i] ? { ...t, texto: traducciones[i], verOriginal: VER_ORIGINAL[idioma] } : t
      )
    : TESTIMONIOS[idiomaDeTestimonios(idioma)];
  if (!slug || !FICHAS_SIN_TESTIMONIOS_DE_OTRO_LIBRO.includes(slug)) return items;
  // Se queda el que no nombra ningún libro y el que nombra a este.
  return items.filter((t) => !t.libros?.length || t.libros.includes(slug));
}

export function verCaptura(locale) {
  const { locale: idioma } = leerDestino(locale);
  return VER_CAPTURA[idioma] || VER_CAPTURA.es;
}
